import { customScrollMinimal, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

import { ErrorMessageWrapper } from '~/components/error-message-wrapper/ErrorMessageWrapper';

const footerHeight = '56px';

export const Content = styled.div<{ $hasFooter: boolean }>`
  ${customScrollMinimal};
  overflow-y: auto;
  height: calc(100% - ${footerHeight});
  padding: 20px 20px 80px 20px;

  ${({ $hasFooter }) =>
    !$hasFooter &&
    css`
      height: 100%;
      &:after {
        bottom: 0;
      }
    `}
`;

export const Footer = styled.footer`
  width: 100%;
  height: ${footerHeight};
  padding: 0px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid var(--border-soft);
  position: relative;

  svg {
    fill: var(--icon-primary);
  }
`;

export const StyledErrorMessage = styled(ErrorMessageWrapper)`
  border: none;
  display: flex;
`;

export const DowJonesDisclaimer = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;
